import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      stroke: "#000",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.4",
      d: "M11.468 6.866a.7.7 0 0 0 1.064 0c.522-.61 1.402-1.276 2.753-1.276 2.334 0 4.015 2.225 4.015 4.416 0 2.288-1.435 4.39-3.177 5.968A13.7 13.7 0 0 1 13.58 17.8c-.388.213-.736.37-1.021.474-.3.108-.483.138-.56.138s-.26-.03-.56-.138a7.5 7.5 0 0 1-1.02-.474 13.7 13.7 0 0 1-2.543-1.826C6.135 14.396 4.7 12.294 4.7 10.006c0-2.19 1.682-4.416 4.015-4.416 1.351 0 2.231.665 2.753 1.276"
    }, null, -1),
    _createElementVNode("path", { d: "m9.75 10.75 2.652 2.652-1.06 1.06-2.653-2.651z" }, null, -1),
    _createElementVNode("path", { d: "m10.5 13.63 4.243-4.243 1.06 1.061-4.242 4.243z" }, null, -1)
  ])))
}
export default { render: render }